import { Select, MenuItem, InputLabel, FormControl, Checkbox, ListItemText, InputAdornment } from "@mui/material";
import React, { useState } from "react";
import { Close, Loader } from "../../assets/images/index";
import "./multi-select.scss";

interface DropdownOption {
  value: string;
  label: string;
}

interface MultiSelectDropdownProps {
  label: string;
  value: string[];
  options: DropdownOption[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  loading?: boolean;
  required?: boolean;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
  loading = false,
  required = false,
}) => {
  const [open, setOpen] = useState(false);

  const renderLabel = () => {
    if (!required) return label;
    return (
      <span>
        {label} <span className="required-asterisk">*</span>
      </span>
    );
  };

  return (
    <div className={`dropdown-container ${loading ? "loading" : ""}`}>
      <FormControl
        fullWidth
        size="small"
        className={`${disabled || loading ? "disabled-dropdown" : ""}`}
      >
        <InputLabel>{renderLabel()}</InputLabel>
        <Select
          multiple
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          value={value}
          onChange={(e) => {
            const selectedValues = (e.target.value as string[]).filter(
              (val) => val !== undefined
            );
            onChange(selectedValues);
          }}
          label={renderLabel()}
          renderValue={(selected) => (
            <div className="multi-select-display-value">
              {selected
                .map((val) => options.find((opt) => opt.value === val)?.label)
                .join(", ")}
            </div>
          )}
          disabled={disabled || loading}
          MenuProps={{
            className: "multi-select-menu-root",
            PaperProps: {
              className: "multi-select-menu-paper",
            },
          }}
        >
          <div className="close-button-wrapper">
            <img
              src={Close}
              alt="close"
              className="close-button-icon"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
            />
          </div>
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <Checkbox checked={value.indexOf(opt.value as string) > -1} />
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && (
        <div className="loader-container">
          <img src={Loader} alt="loading" className="loader-icon" />
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
